package system.single

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import component.*

class PlayerTrapSystem : IteratingSystem(family { all(PlayerComponent) }) {

    private var timeAccumulator = 0f

    override fun onTickEntity(entity: Entity) {
        val playerComp = entity[PlayerComponent]
        if (playerComp.playerMetadata.playerPhysicState.isOnTrap) {
            if (timeAccumulator >= TRAP_TIME) {
                playerComp.playerMetadata.playerPhysicState.resetTraps()
                timeAccumulator = 0f
                return
            }

            val physicComp = entity[PhysicComponent]
            physicComp.body.linearVelocity.setZero()

            timeAccumulator += deltaTime
        }
    }

    companion object {
        const val TRAP_TIME = 0.5f
    }
}
